import { Reservation, ReservationTourist, TouristDocumentDto } from '@appTypes/api.types';
import { ResTouristDocsUploadFormData, SearchReservationPaging } from '@pages/reservations-page/reservations.type';

export class reservationsReset {
  static readonly type = '[Reservations] Reset';
}

export class reservationsGetCountries {
  static readonly type = '[Reservations] GetCountries';
  constructor(public refresh = false) {}
}

export class reservationsSearch {
  static readonly type = '[Reservations] Search';
  constructor(public paging?: SearchReservationPaging) {}
}

/**
 * Re-reads one reservation of the search results from the API and replaces it in place, so a
 * status changed in NugiosCore since the search reaches the row and the popups opened from it
 * without a new search (KM-5604).
 */
export class reservationRefresh {
  static readonly type = '[Reservations] Refresh';
  constructor(public reservationId: string) {}
}

export class reservationsDownloadDocument {
  static readonly type = '[Reservations] DownloadDocument';
  constructor(
    public url: string,
    public name: string,
    /** When true, `name` is used as-is and the server's Content-Disposition filename is ignored */
    public preferProvidedName = false
  ) {}
}

export class reservationOpenPriceDetails {
  static readonly type = '[Reservations] OpenPriceDetails';
  constructor(public reservation: Reservation) {}
}
export class reservationOpenDocuments {
  static readonly type = '[Reservations] OpenDocuments';
  constructor(public reservation: Reservation) {}
}

export class reservationOpenTouristEditForm {
  static readonly type = '[Reservations] OpenTouristEditForm';
  constructor(public tourist: ReservationTourist) {}
}
export class reservationOpenTouristDocUploadForm {
  static readonly type = '[Reservations] OpenTouristDocUploadForm';
  constructor(public payload: ResTouristDocsUploadFormData) {}
}

export class reservationResetSearchResult {
  static readonly type = '[Reservations] ResetSearchResult';
}

export class reservationUploadTouristDocument {
  static readonly type = '[Reservations] UploadTouristDocument';
  constructor() {}
}
export class reservationGetTouristDocuments {
  static readonly type = '[Reservations] GetTouristDocuments';
  /** `rfid` = the reservation the tourist is on: the server proves it belongs to the agent's agency (website/reservations-api#7). */
  constructor(
    public touristId: string,
    public rfid: string
  ) {}
}
export class reservationDownloadTouristDocument {
  static readonly type = '[Reservations] DownloadTouristDocument';
  constructor(
    public document: TouristDocumentDto,
    public touristId: string,
    public rfid: string
  ) {}
}
export class reservationDeleteTouristDocument {
  static readonly type = '[Reservations] DeleteTouristDocument';
  constructor(
    public document: TouristDocumentDto,
    public touristId: string,
    public rfid: string
  ) {}
}
